import io from 'socket.io-client';

const socket = {
    connection: null,
    connect(props) {
        if (this.connection) {
            return this.connection;
            
            
            this.disconnect();
        }

        if (props.userId) {
            this.connection = io.connect('/v1', {
                path: '/socket.io',
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionDelay: 500,
                reconnectionAttempts: Number.MAX_VALUE,
            });

            this.connection.on('connected', (message) => {
                //  console.log('connect', message);
                this.connection.emit('messages:get');
            });

            this.connection.on('disconnect', () => {
                //  console.log('disconnect');
            });

            this.connection.on('messages:receive', () => {
            //    console.log('messages:receive');
            });
            return this.connection;
        }
    },

    disconnect() {
        if (this.connection) {
            this.connection.off('messages:receive');
            this.connection.disconnect();
            this.connection = null;
        }
    },
};

export default socket;



// WEBPACK FOOTER //
// ./app/sockets/index.js